import {
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../constants/partTypes";
import { Language } from "../i18n/useLanguage";
import { AnyPartItem } from "../stores/slices/cartSlice";
import { fixTireImageUrl } from "./fixTireImageUrl";
import { getPartFallbackSrc } from "./getPartFallbackSrc";
import { getPartName } from "./getPartName";

export type NormalizedPartData = {
  fallbackSrc: string;
  name: string;
  shouldFlip?: boolean;
  src: string;
};

interface NormalizePartData {
  (part: AnyPartItem, language: Language): NormalizedPartData;
  (
    part: AnyPartItem | null | undefined,
    language: Language
  ): NormalizedPartData | null;
}

export const normalizePartData: NormalizePartData = (part, language) => {
  const name = getPartName(part, language);
  switch (part?.partDetails.primaryPart.itemType) {
    case partTypeAccessory:
      return {
        fallbackSrc: getPartFallbackSrc(partTypeAccessory),
        name,
        src: part.partDetails.primaryPart.accessoryImageLink,
      };
    case partTypePackage:
      return {
        fallbackSrc: getPartFallbackSrc(partTypePackage),
        name,
        src: part.partDetails.primaryPart.packageImageLink,
      };
    case partTypeTire:
      return {
        fallbackSrc: getPartFallbackSrc(partTypeTire),
        name,
        shouldFlip: true,
        src: fixTireImageUrl(part.partDetails.primaryPart.tireImageLink),
      };
    case partTypeWheel:
      return {
        fallbackSrc: getPartFallbackSrc(partTypeWheel),
        name,
        src: part.partDetails.primaryPart.wheelImageLink,
      };
    default:
      return null as unknown as NormalizedPartData;
  }
};
